<template>
  <el-dialog
    :title="cp_title"
    width="500px"
    :visible.sync="visible"
    :before-close="fn_beforeClose"
    append-to-body
    center
    :lock-scroll="false"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="v-tdBindMobile"
  >
    <div class="bind-moblie">
      <span>手机号</span>
      <div class="my-inputgroup">
        <el-select v-if="pr_type !== 'cg'" class="my-area-select" v-model="activeAreaCode" placeholder="请选择">
          <el-option
            v-for="item in areaCodeList"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
        <el-input
          class="my-area-input"
          v-model="dt_mobile.value"
          placeholder="请输入手机号"
          type="number"
          clearable
          @input="dt_mobile.error = false"
        ></el-input>
      </div>
    </div>
    <p class="bind-hint" v-if="dt_mobile.error">手机号码格式有误</p>
    <div class="bind-moblie">
      <span>验证码</span>
      <el-input
        v-model="dt_code.value"
        style="flex: 1"
        placeholder="请输入验证码"
        type="number"
        clearable
        @input="dt_code.error = false"
      ></el-input>
      <el-button
        type=""
        size="small"
        style="height:40px;margin-left:10px;width:100px;"
        @click="pr_type === 'cg' ? fn_sendCode() : toggleImgVerif(true)"
      >{{ cp_isCodeText }}</el-button>
    </div>
    <p class="bind-hint" v-if="dt_code.error">验证码格式有误</p>
    <div class="bind-moblie" v-if="pr_type === 'mx'">
      <span>设置密码</span>
      <el-input
        v-model="dt_psw.value"
        style="flex: 1"
        maxlength="12"
        placeholder="6～12位数字、字母组合"
        clearable
        show-password
        @input="dt_psw.error = false"
      ></el-input>
    </div>
    <p class="bind-hint" v-if="pr_type === 'mx' && dt_psw.error">密码格式有误</p>
    <span slot="footer">
      <el-button size="small" type="primary" @click="fn_confirm">确 定</el-button>
      <el-button size="small" @click="fn_beforeClose">取 消</el-button>
    </span>
    <BaseImgVerif v-if="isShowImgVerif" :fullscreen="false" :headIn="true" @success="fn_sendCode" @close="toggleImgVerif(false)" />
  </el-dialog>
</template>

<script>
import { axiosUserGetIndentity, axiosBindAccountSecurity, axiosGetCode, axiosPhoneBindVerif, axiosBindMobile } from '@/service/api.js'
import { areaCodeList } from '@/constants'
import BaseImgVerif from '@/components/BaseImgVerif.vue';

export default {
  components: {
    BaseImgVerif
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    pr_type: {
      type: String,
      default: 'mx'
    }
  },
  data() {
    return {
      dt_mobile: {
        value: "",
        error: false
      },
      dt_code: {
        value: "",
        error: false
      },
      dt_psw: {
        value: '',
        error: false
      },
      dt_waitTime: 0,
      dt_isFirstSend: false,
      dt_times: null,
      dt_shakeTimes: null,
      activeAreaCode: '86',
      areaCodeList,
      isShowImgVerif: false,
    }
  },
  computed: {
    cp_isCodeText() {
      return this.dt_waitTime >= 1 ? `(${this.dt_waitTime}s)后重发` : (this.dt_isFirstSend ? '重新发送' : '获取验证码')
    },
    cp_title() {
      return (this.pr_type == 'mx' ? '木夕' : '橙光') + `账号绑定手机号`;
    }
  },
  methods: {
    ut_antiShake(callback) {
      clearTimeout(this.dt_shakeTimes);
      this.dt_shakeTimes = setTimeout(() => {
        clearTimeout(this.dt_shakeTimes);
        callback();
      }, 500)
    },
    fn_beforeClose() {
      this.$emit('update:visible', false)
    },
    toggleImgVerif(v = !this.isShowImgVerif) {
      if (v) {
        if (this.dt_waitTime != 0) return;
        this.ut_verify(() => {
          this.isShowImgVerif = v
        }, 'phone')
        return
      }
      this.isShowImgVerif = v
    },
    fn_sendCode() {
      if (this.dt_waitTime != 0) return;
      this.ut_antiShake(() => {
        this.ut_verify(async () => {
          try {
            let isOks, msgs;
            if (this.pr_type == 'mx') {
              let { isOk, msg } = await axiosGetCode(this.dt_mobile.value, this.activeAreaCode);
              isOks = isOk;
              msgs = msg || '验证码发送失败';
            } else {
              let { isOk, message } = await axiosUserGetIndentity(this.dt_mobile.value)
              isOks = isOk;
              msgs = message.title || '验证码发送失败';
            }

            if (isOks) {
              this.dt_isFirstSend = this.dt_isFirstSend || true;
              this.dt_waitTime = 60;
              this.ut_countDown();
            } else {
              this.$message.error(msgs);
            }
          } catch (e) {
            console.warn('验证码发送失败', e);
          }
        }, 'phone')
      })
    },
    fn_confirm() {
      this.ut_antiShake(() => {
        this.ut_verify(async () => {
          try {
            let isOks, msg;
            if (this.pr_type == 'mx') {
              let reslut = await axiosPhoneBindVerif(this.dt_mobile.value, this.dt_code.value, this.activeAreaCode);
              if (!reslut.isOk) {
                this.$message({
                  message: reslut.message.title,
                  type: 'error'
                });
                return;
              }
              let { isOk, message, code } = await axiosBindMobile(this.dt_mobile.value, this.dt_psw.value, this.activeAreaCode);
              if (!isOk && code == 500019) {
                this.$emit('bind_merge', this.dt_mobile.value, 0, this.dt_psw.value, this.activeAreaCode);  // PS: 0 表示账户类型为手机号
                return
              }
              isOks = isOk;
              msg = message;
            } else {
              let { isOk, message } = await axiosBindAccountSecurity(this.dt_mobile.value, this.dt_code.value);
              isOks = isOk;
              msg = message;
            }
            if (!isOks) {
              this.$message.error(msg.title);
            } else {
              this.$message.success("绑定手机号成功");
              this.$emit('bind_succeed', this.dt_mobile.value);
              this.fn_beforeClose();
            }
          } catch (e) {
            console.warn('绑定手机号失败', e);
          }
        })
      })
    },
    // 验证
    ut_verify(callback, type) {
      let activeAreaItem = this.areaCodeList.find(d => d.value == this.activeAreaCode) || this.areaCodeList[0]
      if (this.dt_mobile.value == '' || !activeAreaItem.reg.test(this.dt_mobile.value)) {
        this.dt_mobile.error = true;
        return;
      } else {
        this.dt_mobile.error = false;
      }
      if (type == 'phone') {
        callback && callback();
        return
      };

      if (this.dt_code.value == "" || this.dt_code.value.length < 4) {
        this.dt_code.error = true;
        return;
      } else {
        this.dt_code.error = false;
      }

      if (this.pr_type === 'mx') {
        let v = !(this.dt_psw.value.length >= 6 && this.dt_psw.value.length <= 12)
        this.dt_psw.error = v
        if (v) return;
      }
      callback && callback();
    },
    // 倒计时
    ut_countDown() {
      clearInterval(this.dt_times);
      this.dt_times = setInterval(() => {
        --this.dt_waitTime;
        if (this.dt_waitTime == 0) {
          clearInterval(this.dt_times);
        }
      }, 1000)
    },
  }
}
</script>
<style scoped lang="less">
.tdBindMobile-hint {
  margin-top: -20px;
  padding: 15px 0 30px;
  font-size: 14px;
  text-align: center;
  color: gray;
}
.bind-moblie {
  display: flex;
  width: 400px;
  margin-bottom: 25px;
  & > span {
    width: 80px;
    line-height: 40px;
  }
}
.bind-hint {
  position: absolute;
  color: red;
  font-size: 14px;
  margin-left: 80px;
  margin-top: -20px;
}
.my-inputgroup {
  display: flex;
  flex: 1;
}
.my-area-select {
  width: 120px;
  margin-right: 10px;
}
</style>